import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'


const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

export const constRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    redirect: '/project',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home
      },
      //权限管理
      {
        path: 'author',
        name: 'author',
        component: () => import('../views/author/author.vue'),
        meta: {
          title: 'author'
        }
      },
      //修改密码
      {
        path: 'author/detail',
        name: 'authorDetail',
        component: () => import('../views/author/authorDetail.vue'),
        meta: {
          title: 'author'
        }
      },
      {
        path: 'author/change',
        name: 'authorChange',
        component: () => import('../views/author/authorChange.vue'),
        meta: {
          title: 'author'
        }
      },
      {
        path: 'author/view',
        name: 'authorView',
        component: () => import('../views/author/authorView.vue'),
        meta: {
          title: 'author'
        }
      },
      {
        path: 'author/build',
        name: 'authorBuild',
        component: () => import('../views/author/authorBuild.vue'),
        meta: {
          title: 'author'
        }
      },
      //log
      {
        path: 'adminLog',
        name: 'adminLog',
        component: () => import('../views/other/adminLog.vue'),
        meta: {
          title: 'adminLog'
        }
      },
      //办公用品
      {
        path: 'assest',
        name: 'assest',
        component: () => import('../views/other/assest.vue'),
        meta: {
          title: 'assest'
        }
      },
      {
        path: 'assest/add',
        name: 'assestAdd',
        component: () => import('../views/other/assestAdd.vue'),
        meta: {
          title: 'assestAdd'
        }
      },
      {
        path: 'assest/view',
        name: 'assestView',
        component: () => import('../views/other/assestView.vue'),
        meta: {
          title: 'assestView'
        }
      },
      {
        path: 'assest/invoice',
        name: 'assestInvoice',
        component: () => import('../views/other/assestInvoice.vue'),
        meta: {
          title: 'assestInvoice'
        }
      },
      // 项目管理
      {
        path: 'project',
        name: 'Project',
        component: () => import('../views/project/pro.vue'),
        meta: {
          title: 'project'
        },
      },
      {
        path: 'project/add',
        name: 'projectAdd',
        component: () => import('../views/project/proDetail.vue'),
        meta: {
          title: 'project'
        },
      },
      {
        path: 'project/contract',
        name: 'projectContract',
        component: () => import('../views/project/proContract.vue'),
        meta: {
          title: 'project'
        },
      },
      {
        path: 'project/bill',
        name: 'projectBill',
        component: () => import('../views/project/proBill.vue'),
        meta: {
          title: 'project'
        },
      },
      {
        path: 'project/son',
        name: 'projectSon',
        component: () => import('../views/project/proSon.vue'),
        meta: {
          title: 'project'
        },
      },
      {
        path: 'project/detail',
        name: 'projectDetail',
        component: () => import('../views/project/proView.vue'),
        meta: {
          title: 'project'
        },
      },
      {
        path: 'project/pay',
        name: 'projectPay',
        component: () => import('../views/project/proPay.vue'),
        meta: {
          title: 'project'
        },
      },
      // 销售管理
      {
        path: 'client',
        name: 'Client',
        component: () => import('../views/sale/client.vue'),
        meta: {
          title: 'Client'
        },
      },
      {
        path: 'client/add',
        name: 'clientAdd',
        component: () => import('../views/sale/clientDetail.vue'),
        meta: {
          title: 'Client'
        },
      },
      {
        path: 'client/view',
        name: 'clientView',
        component: () => import('../views/sale/clientView.vue'),
        meta: {
          title: 'clientView'
        },
      },
      {
        path: 'apply',
        name: 'Apply',
        component: () => import('../views/sale/apply.vue'),
        meta: {
          title: 'apply'
        },
      },
      {
        path: 'apply/add',
        name: 'applyAdd',
        component: () => import('../views/sale/applyDetail.vue'),
        meta: {
          title: 'applyAdd'
        },
      },
      {
        path: 'apply/update',
        name: 'applyUpdate',
        component: () => import('../views/sale/applyUpdate.vue'),
        meta: {
          title: 'applyUpdate'
        },
      },
      {
        path: 'apply/view',
        name: 'applyView',
        component: () => import('../views/sale/applyView.vue'),
        meta: {
          title: 'applyView'
        },
      },
      {
        path: 'apply/pay',
        name: 'applyPay',
        component: () => import('../views/sale/applyPay.vue'),
        meta: {
          title: 'applyPay'
        },
      },
      {
        path: 'invoice',
        name: 'Invoice',
        component: () => import('../views/sale/invoice.vue'),
        meta: {
          title: 'invoice'
        },
      },
      {
        path: 'invoice/view',
        name: 'invoiceDetail',
        component: () => import('../views/sale/invoiceView.vue'),
        meta: {
          title: 'invoice'
        },
      },
      // 供应商管理
      {
        path: 'vendor',
        name: 'Vendor',
        component: () => import('../views/vendor/vendor.vue'),
        meta: {
          title: 'vendor'
        },
      },
      {
        path: 'vendor/add',
        name: 'vendorAdd',
        component: () => import('../views/vendor/vendorDetail.vue'),
        meta: {
          title: 'vendor'
        },
      },
      {
        path: 'vendor/view',
        name: 'vendorView',
        component: () => import('../views/vendor/vendorView.vue'),
        meta: {
          title: 'vendorView'
        },
      },
      {
        path: 'purchase',
        name: 'Purchase',
        component: () => import('../views/vendor/purchase.vue'),
        meta: {
          title: 'purchase'
        },
      },
      {
        path: 'purchase/add',
        name: 'purchaseAdd',
        component: () => import('../views/vendor/purchaseDetail.vue'),
        meta: {
          title: 'purchase'
        },
      },
      {
        path: 'purchase/view',
        name: 'purchaseView',
        component: () => import('../views/vendor/purchaseView.vue'),
        meta: {
          title: 'purchaseView'
        },
      },
      {
        path: 'pay',
        name: 'Pay',
        component: () => import('../views/vendor/pay.vue'),
        meta: {
          title: 'pay'
        },
      },
      {
        path: 'pay/add',
        name: 'payAdd',
        component: () => import('../views/vendor/payDetail.vue'),
        meta: {
          title: 'pay'
        },
      },
      {
        path: 'pay/plan',
        name: 'payPlan',
        component: () => import('../views/vendor/payPlan.vue'),
        meta: {
          title: 'pay'
        },
      },
      {
        path: 'pay/invoice',
        name: 'payInvoice',
        component: () => import('../views/vendor/payInvoice.vue'),
        meta: {
          title: 'pay'
        },
      },
      {
        path: 'pay/check',
        name: 'payCheck',
        component: () => import('../views/vendor/payCheck.vue'),
        meta: {
          title: 'pay'
        },
      },
      {
        path: 'pay/view',
        name: 'payView',
        component: () => import('../views/vendor/payView.vue'),
        meta: {
          title: 'payView'
        },
      },
      //行政和人力资源
      {
        path: 'admin',
        name: 'admin',
        component: () => import('../views/admin/ad.vue'),
        meta: {
          title: 'admin'
        },
      },
      {
        path: 'admin/add',
        name: 'ahAdd',
        component: () => import('../views/admin/ahDetail.vue'),
        meta: {
          title: 'ahDetail'
        },
      },
      {
        path: 'admin/view',
        name: 'adView',
        component: () => import('../views/admin/ahView.vue'),
        meta: {
          title: 'ahView'
        },
      },
      {
        path: 'admin/son',
        name: 'ahSon',
        component: () => import('../views/admin/ahSon.vue'),
        meta: {
          title: 'ahSon'
        },
      },
      {
        path: 'adminPay/add',
        name: 'adminPayAdd',
        component: () => import('../views/admin/ahPayDetail.vue'),
        meta: {
          title: 'adminPayAdd'
        },
      },
      {
        path: 'adminPay/view',
        name: 'adminPayView',
        component: () => import('../views/admin/ahPayView.vue'),
        meta: {
          title: 'adminPayView'
        },
      },
      {
        path: 'human',
        name: 'human',
        component: () => import('../views/admin/hr.vue'),
        meta: {
          title: 'human'
        },
      },
      {
        path: 'adPay',
        name: 'adPay',
        component: () => import('../views/admin/adPay.vue'),
        meta: {
          title: 'adPay'
        },
      },
      {
        path: 'hrPay',
        name: 'hrPay',
        component: () => import('../views/admin/hrPay.vue'),
        meta: {
          title: 'hrPay'
        },
      },
      {
        path: 'adPurchase',
        name: 'adPurchase',
        component: () => import('../views/admin/adPurchase.vue'),
        meta: {
          title: 'adPurchase'
        },
      },
      {
        path: 'hrPurchase',
        name: 'hrPurchase',
        component: () => import('../views/admin/hrPurchase.vue'),
        meta: {
          title: 'hrPurchase'
        },
      },
      //报销管理
      {
        path: 'expense',
        name: 'expense',
        component: () => import('../views/expense/expense.vue'),
        meta: {
          title: 'expense'
        },
      },
      {
        path: 'expense/person',
        name: 'expense',
        component: () => import('../views/expense/expensePerson.vue'),
        meta: {
          title: 'expense'
        },
      },
      {
        path: 'expense/add',
        name: 'expenseDetail',
        component: () => import('../views/expense/expenseDetail.vue'),
        meta: {
          title: 'expenseDetail'
        },
      },
      {
        path: 'expense/view',
        name: 'expenseView',
        component: () => import('../views/expense/expenseView.vue'),
        meta: {
          title: 'expenseView'
        },
      },
      {
        path: 'expense/pay',
        name: 'expensePay',
        component: () => import('../views/expense/expensePay.vue'),
        meta: {
          title: 'expensePay'
        },
      },
      //请假管理
      {
        path: 'vacation',
        name: 'vacation',
        component: () => import('../views/vacation/vacation.vue'),
        meta: {
          title: 'vacation'
        },
      },
      {
        path: 'vacation/detail',
        name: 'vacationDetail',
        component: () => import('../views/vacation/vacaDetail.vue'),
        meta: {
          title: 'vacaDetail'
        },
      },
      {
        path: 'vacation/add',
        name: 'vacationDetail',
        component: () => import('../views/vacation/vacaAdd.vue'),
        meta: {
          title: 'vacaAdd'
        },
      },
      {
        path: 'vacation/view',
        name: 'vacationDetail',
        component: () => import('../views/vacation/vacaView.vue'),
        meta: {
          title: 'vacaView'
        },
      },
      //角色
      {
        path: 'role',
        name: 'role',
        component: () => import('../views/role/role.vue'),
        meta: {
          title: 'role'
        },
      },
      {
        path: 'role/detail',
        name: 'roleDetail',
        component: () => import('../views/role/roleDetail.vue'),
        meta: {
          title: 'role'
        },
      },
      //刊例
      {
        path: 'pubcase',
        name: 'pubcase',
        component: () => import('../views/pubcase/pubcase.vue'),
        meta: {
          title: 'pubcase'
        },
      },
      // {
      //   path: 'pubcase/add',
      //   name: 'pubcaseDetail',
      //   component: () => import('../views/pubcase/pubcaseAdd.vue'),
      //   meta: {
      //     title: 'pubcaseAdd'
      //   },
      // },
      // {
      //   path: 'pubcase/view',
      //   name: 'pubcaseView',
      //   component: () => import('../views/pubcase/pubcaseView.vue'),
      //   meta: {
      //     title: 'pubcaseView'
      //   },
      // },
      {
        path: 'pubcase/sim',
        name: 'pubcaseSim',
        component: () => import('../views/pubcase/pubcaseSim.vue'),
        meta: {
          title: 'pubcaseSim'
        },
      },
    ]
  },
]

// 权限页面：受保护页面，要求用户登录并拥有访问权限的角色才能访问
export const asyncRoutes = []

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: constRoutes,
})


